import { useApiErrorToast } from '@shared/api/hooks/useApiErrorToast';

export function useBadRequestHandling() {
  const apiErrorToast = useApiErrorToast();

  async function withBadRequestHandling<T>(callback: () => Promise<T>): Promise<T> {
    try {
      return await callback();
    } catch (error) {
      apiErrorToast(error);

      throw error;
    }
  }

  return { withBadRequestHandling };
}
